import { useCallback, useState } from 'react';
import { useApi } from '../../api/hooks/useApi';
import { Post } from '../../types';

export function useSearchPosts(courseId?: string) {
  const { request } = useApi();
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const searchPosts = useCallback(async (query: string) => {
    if (!query) {
      setPosts([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await request(`api/posts?searchTerm=${encodeURIComponent(query)}&courseId=${courseId}`);
      setPosts(res.posts || []);
    } catch (err) {
      console.error(err);
      setError('Erro ao buscar posts');
    } finally {
      setLoading(false);
    }
  }, []);

  return { posts, loading, error, searchPosts };
}
